import OrderList from '../../slices/subscription/OrderList'
import PaymentList from '../../slices/subscription/PaymentList'

const subscriptionReducer = {
    subscriptionOrderList: OrderList,
    subscriptionPaymentList: PaymentList,
};

export default subscriptionReducer;
